/* eslint-disable react/no-unused-prop-types */
import React, { createContext, useContext } from 'react'

interface ContextProps {
  translation: (value: string) => string
}

const UiKitContext = createContext<ContextProps>({
  translation: (value: string) => value,
})

const UiKitProvider: React.FC<ContextProps & { children: React.ReactNode }> = (
  props
) => {
  const { children, ...restProps } = props

  return (
    <UiKitContext.Provider value={restProps}>{children}</UiKitContext.Provider>
  )
}

const useUiKitContext = () => useContext(UiKitContext)

export { UiKitProvider, useUiKitContext }
